export class KError extends Error {}
